exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mb{background:#f2f2f2;border:1px solid #d5dde2;box-shadow:0 4px 20px rgba(0,0,0,.05);margin:0 0 30px;max-width:800px;padding:20px\n}\n.mb__content>:last-child{margin-bottom:0\n}\n.mb__cancel{font-size:12px\n}\n.mb__header{border-bottom:1px solid rgba(0,0,0,.1);margin-bottom:15px;padding-bottom:15px\n}\n.mb__header h1{line-height:1.1;margin:0 0 10px\n}\n@media screen and (min-width:500px){\n.mb{padding:30px\n}\n.mb__header{align-items:center;display:flex;justify-content:flex-end;min-height:55px\n}\n.mb__header h1{margin:0 auto 0 0\n}\n.mb__header>*{margin:0 10px\n}\n}", ""]);

// exports
